// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Prompts & Blessings Configuration
// ═══════════════════════════════════════════════════════════════════════════
// Edit these to change the spiritual content and prompts.
// ═══════════════════════════════════════════════════════════════════════════

export const PROMPTS = {
    // ─────────────────────────────────────────────────────────────────────────
    // BREATHING PROMPTS
    // Shown during sacred silence mode between verses
    // ─────────────────────────────────────────────────────────────────────────
    breathingPrompts: [
        "Breathe.",
        "Be still.",
        "Listen.",
        "Rest here.",
        "Receive.",
        "Be present.",
    ],

    // ─────────────────────────────────────────────────────────────────────────
    // SESSION END REFLECTIONS
    // Questions shown at the end of a session
    // ─────────────────────────────────────────────────────────────────────────
    sessionEndPrompts: [
        "What stirred in you?",
        "What are you being invited into?",
        "What did you resist?",
        "Who came to mind?",
        "What do you want to hold onto?",
        "Where did you feel drawn?",
        "What surprised you?",
        "What felt like home?",
    ],

    // ─────────────────────────────────────────────────────────────────────────
    // BLESSINGS
    // Shown at session end after reflection
    // ─────────────────────────────────────────────────────────────────────────
    blessings: [
        "May these words dwell in you richly.",
        "Go gently. You are held.",
        "The Word goes with you.",
        "Grace upon grace.",
        "You are seen. You are loved.",
        "Peace be your portion today.",
        "May you carry this stillness with you.",
        "These words are now written on your heart.",
    ],

    // ─────────────────────────────────────────────────────────────────────────
    // DIVINE VERSE INTROS
    // Shown before an unskippable "linger" verse
    // ─────────────────────────────────────────────────────────────────────────
    divineVerseIntro: [
        "Before you scroll on...",
        "Pause here a moment.",
        "This one asks for stillness.",
        "Pause. Let this settle.",
        "Don't rush past this.",
        "Stay with this one.",
    ],

    // ─────────────────────────────────────────────────────────────────────────
    // RAPID SCROLL INTERVENTION
    // Shown when user is scrolling too fast
    // ─────────────────────────────────────────────────────────────────────────
    rapidScrollMessages: [
        "You're moving quickly. Would you like to pause?",
        "Slow movements, deep roots.",
        "There's no rush here.",
        "The Word isn't going anywhere.",
    ],

    // ─────────────────────────────────────────────────────────────────────────
    // ONBOARDING SCREENS
    // Poetic introduction for first-time users
    // ─────────────────────────────────────────────────────────────────────────
    onboarding: [
        {
            title: "Welcome",
            text: "This is a quiet place.\nA space to encounter, not consume.\nTo receive, not achieve.",
            hint: null,
        },
        {
            title: "How it works",
            text: "Scroll through Scripture.\nHeart what speaks to you.\nLet the rest flow past.",
            hint: "No right answers. No points. Just presence.",
        },
        {
            title: "Begin",
            text: "\"These words shall be on your heart.\"\n— Deuteronomy 6:6",
            hint: "Enter gently.",
        },
    ],

    // ─────────────────────────────────────────────────────────────────────────
    // EMPTY FAVORITES MESSAGE
    // Shown when user has no saved verses yet
    // ─────────────────────────────────────────────────────────────────────────
    emptyFavorites: {
        title: "Your heart's collection",
        text: "Verses you heart will appear here,\nlike stones gathered on a path.",
    },

    // ─────────────────────────────────────────────────────────────────────────
    // SESSION SUMMARY HEADER
    // Shown at session end above saved verses
    // ─────────────────────────────────────────────────────────────────────────
    sessionSummaryHeader: "Today, this was written on your heart:",
};

export default PROMPTS;
